export const set_Farm_List = (state, Farm_List) => {
  state.Farm_List = Farm_List;
};

export const set_Véhicule_list = (state, véhicule_list) => {
  state.véhicule_list = véhicule_list;
};

export const set_employés_Table = (state, employés_Table) => {
  state.employés_Table = employés_Table;
};

export const set_tache_list = (state, tache_list) => {
  state.tache_list = tache_list;
};
export const set_Variété_list = (state, Variété_list) => {
  state.Variété_list = Variété_list;
};

export const set_parcelle_list = (state, parcelle_list) => {
  state.parcelle_list = parcelle_list;
};
export const set_Compte = (state, compte) => {
  state.compte = compte;
};
export const set_token = (state, token) => {
  state.token = token;
};
